export const state = {
  contactList: [],
}

export const mutations = {
  ADD_CONTACT(state, payload) {
    state.contactList = [payload, ...state.contactList]
  },
  UPDATE_CONTACT(state, payload) {
    state.contactList.map((item) => (item.contactId != payload.contactId ? item : payload))
  },
  DELETE_CONTACT(state, payload) {
    state.contactList = state.contactList.filter((item) => item.contactId != payload)
  },
  RESET_CONTACT(state) {
    state.contactList = []
  },
}
